// PaidInteractionItem.js
'use strict';
import { connect } from 'react-redux';

import PaidInteractionItem from '../component/PaidInteractionItem.jsx';

import notifySendGift from '../action/notifySendGift.js';
import toggleModal from '../action/toggleModal.js';
import login from '../action/login.js';
import openQuickpayModal from '../action/openQuickpayModal.js';
import addvalue from '../action/addvalue.js';
import sendLiveStreamGift from '../action/sendLiveStreamGift.js';
import fetchGift from '../action/fetchGift.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getMeData from '../selector/getMeData.js';
import getMeBalance from '../selector/getMeBalance.js';
import getGiftData from '../selector/getGiftData.js';

import {
  LIVESTREAM_ANIMATION_GIFTS,
  LIVESTREAM_ANIMATION_PAG_GIFTS,
  PUBLIC_PRODUCT_URL_PATH,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId, productId }) => {
  const animationGiftList = getRemoteConfigData(
    state,
    LIVESTREAM_ANIMATION_GIFTS
  );
  const pagGiftList = getRemoteConfigData(
    state,
    LIVESTREAM_ANIMATION_PAG_GIFTS
  );

  const isAnimationGift = !!animationGiftList.includes(productId);
  const isPagGift = !!pagGiftList.includes(productId);

  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const type = getLiveStreamData(
    state,
    [streamId, 'session', sessionId, 'topGift', productId],
    'type'
  );
  const price = getLiveStreamData(
    state,
    [streamId, 'session', sessionId, 'topGift', productId],
    'price'
  );
  const balance = getMeBalance(state);

  return {
    isNeedSendGiftConfirm: getOperationData(
      state,
      ['liveStream'],
      'isNeedSendGiftConfirm'
    ),
    isAnimationGift,
    isPagGift,
    isAuthed: !!getMeData(state, 'id'),
    hasPurchased: getMeData(state, 'hasPurchased'),
    type,
    title: getLiveStreamData(
      state,
      [streamId, 'session', sessionId, 'topGift', productId],
      'title'
    ),
    publicProductUrlPath: getRemoteConfigData(state, PUBLIC_PRODUCT_URL_PATH),
    pagImage: getGiftData(state, productId, 'pagImage'),
    price,
    duration: getLiveStreamData(
      state,
      [streamId, 'session', sessionId, 'topGift', productId],
      'duration'
    ),
    hasEnoughBalance: balance >= price,
  };
};

const mapStateToDispatch = dispatch => {
  return {
    notifySendGift: payload => dispatch(notifySendGift(payload)),
    sendGift: payload => dispatch(sendLiveStreamGift(payload)),
    toggleModal: payload => dispatch(toggleModal(payload)),
    login: () => dispatch(login({ shouldChooseEntryOption: false })),
    addvalue: () => dispatch(addvalue({ via: 'gift' })),
    openQuickpayModal: data => dispatch(openQuickpayModal(data)),
    fetchGift: payload => dispatch(fetchGift(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(PaidInteractionItem);
